<template>
  <!-- 合同下载 -->
  <div class="homeentrust text_center">
    <sec-title
      ac-text="委托"
      Text="律师"
      desc-text="在线发出需求，本地专业律师主动与你沟通，快速挑选满意的律师"
    />
    <div class="content">
      <div class="ent_top between">
        <div class="ent_table">
          <div class="tab_title flex">
            <div class="tb1">案件</div>
            <div style="flex: 1">涉案金额</div>
            <div style="flex: 1">发布时间</div>
          </div>
          <div class="tab_con">
            <div
              class="tab_con_item flex"
              v-for="(item, index) in 5"
              :key="index"
            >
              <div class="tci_1">
                你好，我现在要离婚，可是男方不同意，如果起诉的话，我要怎么做
              </div>
              <div class="tci_pro">5万以下</div>
              <div class="tci_time">15小时前</div>
            </div>
          </div>
        </div>
        <div class="t_l">
          <div class="title between">
            <div><sub-title text="在线委托律师" /></div>
            <div class="mo">更多></div>
          </div>
          <div class="ent_r_adv between">
            <lay-item-win
              style="width: 220px; height: 314px"
              v-for="(item, index) in rightlist"
              :key="index"
			  :item = 'item'
              :consult-or-more="true"
              :is-border="false"
            ></lay-item-win>
          </div>
        </div>
      </div>
      <div class="ent_bottom between">
        <div class="e_b_l">
          <div class="entrust_advant between">
            <div class="ent_adv_item firstimg" >
              <div class="text mar_top18">委托律师的优势</div>
			  <img src="../../../assets/home/arrow.png" class="arrow" >
            </div>
            <div class="ent_adv_item">
              <div><img src="~assets/home/wt_advant_1.png" /></div>
              <div class="mar_top18">免费分析案情</div>
            </div>
            <div class="ent_adv_item">
              <div><img src="~assets/home/wt_advant_2.png" /></div>
              <div class="mar_top18">服务有保障</div>
            </div>
            <div class="ent_adv_item">
              <div><img src="~assets/home/wt_advant_3.png" /></div>
              <div class="mar_top18">经济透明化</div>
            </div>
          </div>
          <div class="ent_adv between">
            <lay-item-win
              style="width: 222px; height: 314px"
              v-for="(item, index) in bottomlist"
              :key="index"
			  :item = 'item'
              :consult-or-more="true"
              :is-border="false"
            ></lay-item-win>
          </div>
        </div>
        <div class="e_b_r">
          <div class="dynamic_case">
            <div class="title"><sub-title text="律师接洽案件动态" /></div>
            <div
              class="dynamic_case_item"
              v-for="(item, index) in 4"
              :key="index"
            >
              <div class="time">26分钟前</div>
              <div class="between">
                <div><img src="~assets/base/small_rentou.png" /></div>
                <div class="text">
                  {{`
                  关键接洽了对于不进赡养义务的代为继承，怎么分割房产的案件委托
                  ` |toEllipsisFilter(40)}}
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import layItemWin from "../components/layItemWin";
import secTitle from "../components/secTitle";
import subTitle from "../components/subTitle";

export default {
  components: {
    secTitle,
    layItemWin,
    subTitle,
  },
  data() {
    return {
		rightlist:[],
		bottomlist:[]
	};
  },
  created() {
  	this.$http.home.lawyerads({
  		ad_id:10,
  		limit:5,
  	}).then(res => {
  		this.rightlist = res.data.data
  	})
  	this.$http.home.lawyerads({
  		ad_id:11,
  		limit:5,
  	}).then(res => {
  		this.bottomlist = res.data.data
  	})
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.homeentrust {
  padding: 50px 0;
  width: 1200px;
  margin: 0 auto;

  .content {
    .ent_top {
      .ent_table {
        width: 710px;
        box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
        .tab_title {
          width: 100%;
          border-radius: 5px;
          background: #f6f6f6;
          font-size: 18px;
          color: #333333;
          text-align: center;
          line-height: 57px;
          .tb1 {
            width: 430px;
          }
        }
        .tab_con {
          width: 100%;
          .tab_con_item {
            font-size: 13px;
            line-height: 60px;
            text-align: center;
            border-bottom: 1px solid #eeeeee;
            .tci_1 {
              text-align: left;
              padding-left: 18px;
              color: #666;
              width: 430px;
            }
            .tci_pro {
              color: #cb0d0e;
              flex: 1;
            }
            .tci_time {
              color: #999999;
              flex: 1;
            }
          }
        }
      }
      .t_l {
        width: 460px;
        align-self: flex-start;
        .title {
          margin-bottom: 20px;
          .mo {
            font-size: 14px;
            color: #666666;
            float: right;
          }
        }
      }
    }
    .ent_bottom {
      margin-top: 30px;
      .e_b_l {
        .entrust_advant {
          width: 710px;
          height: 120px;
          margin-bottom: 60px;
          margin-top: 30px;
          box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
          .ent_adv_bg {
            margin-left: 27px;
            position: relative;
            text-align: left;
            font-size: 22px;
            color: #fff;
            .bgtext {
              position: absolute;
              top: 20px;
              left: 12px;
              line-height: 30px;
            }
          }
		  .firstimg{
			  height: 100%;
			  background: url(../../../assets/home/bg002.png);
			  padding-left: 30px;
			  position: relative;
			  .text{
				  width: 100px;
				  height: 60px;
				  font-size: 22px;
				  font-weight: 500;
				  color: #333333;
				  text-align: left;
			  }
			  .arrow{
				  position: absolute;
				  top: 70px;
				  right: 36px;
			  }
		  }
          .ent_adv_item {
            text-align: center;
            width: 25%;
            color: #333;
            font-size: 16px;
            border-right: 1px solid #eee;
            &:last-child {
              border-right: none;
            }
          }
          .mar_top18 {
            margin-top: 18px;
          }
        }
      }
      .e_b_r {
        width: 460px;
        .title {
          margin-bottom: 20px;
          .mo {
            font-size: 14px;
            color: #666666;
            float: right;
          }
        }
        .dynamic_case {
          padding: 24px 20px 14px;
          box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
          .dynamic_case_item {
            margin-bottom: 25px;
            text-align: left;
            .time {
              margin-bottom: 10px;
              color: #666;
            }
            img {
              width: 54px;
              height: 54px;
              margin-right: 11px;
            }
            .text {
              align-self: start;
              color: #555;
              line-height: 26px;
            }
          }
        }
      }
    }
  }
}
</style>